export default {
  RequestType: "Loại đề xuất",
};
